<template>
  <div>
    <vx-card v-if="isQuotation" class="mt-2 pagebreak-inside-avoid">
      <table class="table table-bordered w-full table-pt">
        <tr class="title p-1 w-full">
          <th colspan="12">PAGAMENTO</th>
        </tr>
        <tr>
          <td class="pl-3">
            <b>Prêmio Líquido</b>:
            {{ functions.formataReal(prizeData.tariff_prize) }}
          </td>
          <td class="pl-3">
            <b>IOF</b>: {{ functions.formataReal(prizeData.iof_value) }}
          </td>
          <td class="pl-3">
            <b>Prêmio Total</b>: {{ functions.formataReal(prizeData.prize) }}
          </td>
        </tr>
      </table>

      <template
        v-if="
          endorsementData &&
          endorsementData.prize &&
          endorsementData.prize.prize > 0
        "
      >
        <table
          v-for="(item, index) in quotationData.paymentMethods"
          :key="index"
          class="table table-bordered table-striped-col"
        >
          <tr class="title p-1 w-full">
            <th :colspan="item.installments.length" class="uppercase">
              {{ item.method }}
            </th>
          </tr>

          <tr>
            <td
              v-for="(parcela, i) in item.installments"
              :key="`p-${i}`"
              class="font-small"
            >
              <b>{{ extractLabel(parcela.label, 'parcelas') }}</b>
            </td>
          </tr>

          <tr>
            <td
              v-for="(parcela, i) in item.installments"
              :key="`v-${i}`"
              class="font-small"
            >
              {{ extractLabel(parcela.label, 'valor') }}
            </td>
          </tr>

          <tr>
            <td
              v-for="(parcela, i) in item.installments"
              :key="`j-${i}`"
              class="font-xsmall"
            >
              {{ extractLabel(parcela.label, 'juros') }}
            </td>
          </tr>
        </table>
      </template>
      <div
        v-if="customSectionsMsgs.PAYMENT"
        style="text-align: justify"
        class="pl-3 pt-3"
        v-html="customSectionsMsgs.PAYMENT"
      ></div>
    </vx-card>
    <vx-card v-else class="mt-2 pagebreak-inside-avoid">
      <table class="table table-bordered">
        <tr class="title p-1 w-full">
          <th colspan="4">PAGAMENTO</th>
        </tr>
        <tr>
          <td class="pl-3">
            <b>Prêmio Líquido</b>:
            {{ functions.formataReal(prizeData.tariff_prize) }}
          </td>
          <td class="pl-3">
            <b>IOF</b>: {{ functions.formataReal(prizeData.iof_value) }}
          </td>
          <td class="pl-3">
            <b>Juros</b>:
            {{ functions.formataReal(prizeData.interest) }}
          </td>
          <td class="pl-3">
            <b>Prêmio Final</b>:
            {{ functions.formataReal(prizeData.prize) }}
          </td>
        </tr>
        <tr>
          <td class="pl-3" v-if="prizeData.prize !== 0">
            <span v-if="prizeData.prize > 0">
              <b>Forma de Pagamento</b>: {{ proposalData.nomePagamento }}</span
            >
            <span v-if="prizeData.prize < 0">
              <b>Forma de Restituição</b>:
              {{ refundMethodDescription }}
            </span>
          </td>
          <td class="pl-3" v-if="showInstallments() && prizeData.prize > 0">
            <b>Nº de Parcelas</b>: {{ endorsementData.prize.installments }} x
            {{ functions.formataReal(endorsementData.prize.monthlyPrize) }}
          </td>
          <td class="pl-3" colspan="2" v-if="prizeData.prize > 0 && dueDate">
            <b>Dia de Vencimento</b>:
            {{ dueDate }}
          </td>
        </tr>
      </table>
      <div
        v-if="refundCompensationScenario"
        style="text-align: justify"
        class="pl-3 pt-3"
      >
        {{ refundCompensationScenarioContent.description }}
      </div>
    </vx-card>
    <vx-card class="mt-2 pagebreak-inside-avoid">
      <table
        v-if="shouldShowImpactedInstallments"
        class="table table-bordered mt-3"
      >
        <tr class="title p-1 w-full">
          <th colspan="4">PARCELAS ALTERADAS</th>
        </tr>
        <tr
          v-for="item in formattedImpactedInstallments"
          :key="`${item.type}-${item.id}`"
        >
          <td class="pl-3"><b>Parcela: </b>{{ item.installmentLabel }}</td>
          <td class="pl-3"><b>Vencimento: </b>{{ item.dueDate }}</td>
          <td class="pl-3">
            <b>Valor anterior: </b>{{ formatCurrencyBRL(item.previousValue) }}
          </td>
          <td class="pl-3">
            <b>Novo valor ou status: </b
            >{{
              item.type === 'changed'
                ? formatCurrencyBRL(item.newValue)
                : item.status
            }}
          </td>
        </tr>
      </table>
    </vx-card>
    <vx-card class="mt-2 pagebreak-inside-avoid">
      <EndorsementRefundPayoutDetails
        v-if="shouldShowRefundPayoutDetails"
        class="mt-3"
        :refund-data="endorsementData.refundData"
        :refund-bank-options="refundBankOptions"
      />
      <div
        v-if="customSectionsMsgs.PAYMENT"
        style="text-align: justify"
        class="pl-3 pt-3"
        v-html="customSectionsMsgs.PAYMENT"
      ></div>
    </vx-card>
  </div>
</template>

<script>
import { PAYMENT_METHODS, PURCHASE_STATUS } from '../../../utils/constants';
import functions from '../../../utils/functions';
import {
  formatImpactedInstallments,
  formatCurrencyBRL,
  getAvailableRefundPayoutMethods,
  getRefundCompensationScenarioContent,
  getRefundCompensationScenario,
  hasImpactedInstallments,
  hasInstallmentToChangeValue,
  isCancellationOperationType,
  REFUND_COMPENSATION_SCENARIOS,
  REFUND_PAYOUT_METHODS,
  shouldShowRefundPayoutSection,
} from '../../../views/pages/Endorsement/utils/refundCompensation';
import EndorsementRefundPayoutDetails from './EndorsementRefundPayoutDetails.vue';

export default {
  name: 'EndorsementContractPayment',
  props: {
    isQuotation: {
      type: Boolean,
      required: false,
      default: false,
    },
    quotationData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    previousPolicy: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    operationType: {
      type: String,
      required: false,
      default: '',
    },
    operationTypeConfig: {
      type: Object,
      required: false,
      default: null,
    },
    endorsementData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    proposalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    prizeData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    refundCompensationData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isLoadingRefundCompensation: {
      type: Boolean,
      required: false,
      default: false,
    },
    refundCompensationError: {
      type: String,
      required: false,
      default: null,
    },
    refundBankOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    dueDate() {
      if (
        this.proposalData.nomePagamento === PAYMENT_METHODS.CREDIT_CARD.name
      ) {
        return this.creditCardDueDate;
      }

      return this.proposalData.diaVencimentoMensalidade;
    },
    isCancellationEndorsement() {
      return isCancellationOperationType(this.operationTypeConfig);
    },
    isBilletPaymentMethod() {
      const paymentMethod =
        this.previousPolicy && this.previousPolicy.paymentMethod;

      return (
        (this.previousPolicy &&
          this.previousPolicy.paymentTypeId === PAYMENT_METHODS.BILLET.id) ||
        (paymentMethod &&
          paymentMethod.toLowerCase() ===
            PAYMENT_METHODS.BILLET.name.toLowerCase())
      );
    },
    isCreditCardPaymentMethod() {
      const paymentMethod =
        this.previousPolicy && this.previousPolicy.paymentMethod;

      return (
        (this.previousPolicy &&
          this.previousPolicy.paymentTypeId ===
            PAYMENT_METHODS.CREDIT_CARD.id) ||
        (paymentMethod &&
          paymentMethod.toLowerCase() ===
            PAYMENT_METHODS.CREDIT_CARD.name.toLowerCase())
      );
    },
    shouldShowRefundCompensation() {
      return (
        !this.isQuotation &&
        this.prizeData.prize < 0 &&
        this.isBilletPaymentMethod &&
        !this.isCancellationEndorsement &&
        (this.isLoadingRefundCompensation ||
          Boolean(this.refundCompensationError) ||
          hasImpactedInstallments(this.refundCompensationData))
      );
    },
    refundCompensationScenario() {
      return getRefundCompensationScenario(this.refundCompensationData);
    },
    refundCompensationScenarioContent() {
      return getRefundCompensationScenarioContent(
        this.refundCompensationScenario,
      );
    },
    shouldShowImpactedInstallments() {
      return hasImpactedInstallments(this.refundCompensationData);
    },
    shouldShowRefundPayoutDetails() {
      if (this.isCreditCardPaymentMethod) {
        return false;
      }

      if (
        this.isCancellationEndorsement &&
        this.endorsementData &&
        this.endorsementData.refundData
      ) {
        return this.prizeData.prize < 0;
      }

      return (
        shouldShowRefundPayoutSection(this.refundCompensationData) &&
        this.endorsementData &&
        this.endorsementData.refundData
      );
    },
    insuredRefundMethodLabel() {
      if (this.isCreditCardPaymentMethod) {
        return PAYMENT_METHODS.CREDIT_CARD.name;
      }

      if (!this.endorsementData || !this.endorsementData.refundData) {
        return this.getRefundMethodName(this.previousPolicy.paymentMethod);
      }

      const payoutMethods = getAvailableRefundPayoutMethods(
        this.endorsementData.refundData,
      );

      if (
        payoutMethods.includes(REFUND_PAYOUT_METHODS.PIX) &&
        payoutMethods.includes(REFUND_PAYOUT_METHODS.BANK_ACCOUNT)
      ) {
        return 'Transferência Bancária ';
      }

      return payoutMethods.includes(REFUND_PAYOUT_METHODS.PIX)
        ? 'Pix'
        : 'Transferência Bancária';
    },
    refundMethodDescription() {
      if (this.isCreditCardPaymentMethod) {
        return PAYMENT_METHODS.CREDIT_CARD.name;
      }

      if (this.isCancellationEndorsement && this.prizeData.prize < 0) {
        return this.insuredRefundMethodLabel;
      }

      switch (this.refundCompensationScenario) {
        case REFUND_COMPENSATION_SCENARIOS.APPLIED_TO_FUTURE_INSTALLMENTS:
          return 'Desconto nas próximas parcelas';
        case REFUND_COMPENSATION_SCENARIOS.PARTIALLY_APPLIED_WITH_RESIDUAL_REFUND:
          return 'Desconto nas próximas parcelas e transferência bancária';
        case REFUND_COMPENSATION_SCENARIOS.FULL_REFUND_TO_INSURED:
          return this.insuredRefundMethodLabel;
        default:
          return this.getRefundMethodName(this.previousPolicy.paymentMethod);
      }
    },
    formattedImpactedInstallments() {
      return formatImpactedInstallments(this.refundCompensationData);
    },
    canceledInstallmentsCount() {
      return Array.isArray(this.refundCompensationData.installmentsToCancel)
        ? this.refundCompensationData.installmentsToCancel.length
        : 0;
    },
    hasChangedInstallment() {
      return hasInstallmentToChangeValue(this.refundCompensationData);
    },
  },
  data() {
    return {
      functions,
      PURCHASE_STATUS,
      creditCardDueDate: 'De acordo com a fatura',
    };
  },
  methods: {
    getRefundMethodName(refundMethod) {
      if (
        refundMethod &&
        refundMethod.toLowerCase() === PAYMENT_METHODS.BILLET.name.toLowerCase()
      ) {
        return 'Transferência Bancária';
      }
      return refundMethod;
    },
    showInstallments() {
      if (
        this.proposalData.nomePagamento !== PAYMENT_METHODS.CREDIT_CARD.name
      ) {
        return true;
      }

      if (
        this.proposalData.purchaseStatus === PURCHASE_STATUS.AUTHORIZED ||
        this.proposalData.purchaseStatus === PURCHASE_STATUS.OVERPAID ||
        this.proposalData.purchaseStatus === PURCHASE_STATUS.PAID
      ) {
        return true;
      }

      return false;
    },
    extractLabel(label, type) {
      const [parcelaPart, valorPart] = label.split(' ');

      if (type === 'parcelas') return parcelaPart;
      if (type === 'valor') return valorPart + ' ' + label.split(' ')[2];
      if (type === 'juros')
        return label.toLowerCase().includes('sem juros')
          ? 'sem juros'
          : 'com juros';

      return '';
    },
    formatCurrencyBRL,
  },
  components: {
    EndorsementRefundPayoutDetails,
  },
};
</script>
